/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_BidirectionalInputs */

const cs_enum_bidirectional = /** @type {(inputs: Enum_BidirectionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obousměrné`)
};

const en_enum_bidirectional = /** @type {(inputs: Enum_BidirectionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bidirectional`)
};

/**
* | output |
* | --- |
* | "Bidirectional" |
*
* @param {Enum_BidirectionalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_bidirectional = /** @type {((inputs?: Enum_BidirectionalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_BidirectionalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_bidirectional(inputs)
	return cs_enum_bidirectional(inputs)
});